<template> 
  <div v-if="!show" class="ui active loader"></div>
  <div v-if="show" id="contain" class="ui center aligned padding grid">
    <div class="ui row imgNameApm">
      <div class="ui content">
        <div class="ui field formulario">
          <form class="ui large form" @submit.prevent="validatePhone">
              <div class="ui field">
                <div class="ui left icon input">
                  <i class="ui mobile alternate icon"></i>
                  <input type="number" inputmode="numeric" name="phone" v-model="phone" maxlength="9" oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" min="0" placeholder="Introduzca su número de móvil" required autofocus>
                </div>
              </div>
            <button id="idBtnBuscar" class="ui fluid large teal button hapiick" type="submit">Buscar</button>
          </form>
        </div>
      </div>
    </div>

    <div class="ui row iconoMsgInfo">
      <div class="ui field icono">
        <i class="info circle icon"></i>
      </div>
      <div class="ui field msgInfo">
        Si tienes algún envío para recoger, recibirás en tu móvil un SMS con un ENLACE para realizar la recogida.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Access',
  props: ['apm','token'],
   data() {
    return {
      phone: null,
      show: false,
      msg: null,
      type: null,
      title: null,
      closeSession: 1,
      codError: null,
      total_shipments: null,
      sms: null,
      totalIntentos: 1,
    }
  },
  created() {
    this.access();
  },
  methods: {
    access() {
      if (!this.token) {
        this.redirect(401,this.title,'','',this.token,this.closeSession);
      } else {
        this.show = true;
      }
    },
    validatePhone() {
      document.getElementById('idBtnBuscar').disabled = true;
      let firstDigit = 0;
      let phoneLength = 0;

      if (this.phone != null) {
        firstDigit = this.phone.substr(0,1);
        phoneLength = this.phone.length
      }

      if ((firstDigit == 6 || firstDigit == 7) && phoneLength == 9 && !isNaN(this.phone)) {
        let url = this.$url_hapiick + '/v1/validations/phone';
        let headers = {
          'Content-Type': 'application/json',
          'X-Auth-Token': this.token,
        }
        if (this.$subscription !== '') {
          headers['Ocp-Apim-Subscription-Key'] = this.$subscription
        }

        this.axios.post(url, {
          apm: this.apm,
          phone: this.phone,
        },{
          headers: headers
        })
        .then(request => {
          this.total_shipments = request.data.total_shipments
          this.codError = request.data.error
          this.sms = request.data.sms

          if (this.codError) {
            this.msg = '';
            this.type = '';
          } else {
            this.codError = '';
            if (this.total_shipments == 0) {
              this.title = 'paquetes_cero';
              this.msg = 'NO tienes envíos pendientes de recoger en la taquilla.';
              this.type = 'info';
            } else {
              if (this.sms > 0) {
                this.msg = 'Se ha enviado un SMS al teléfono introducido para recoger los envíos.';
                this.type = 'success';
                this.closeSession = 0;
              } else {
                this.msg = 'Ha habido algún error a la hora de enviar el SMS. Por favor, vuelve a intentarlo.';
                this.type = 'error';
              }
            }
          }

          this.redirect(this.codError,this.title,this.msg, this.type,this.token, this.closeSession);
        })
        .catch(error => {
          this.catchErrors(error);
        })
      } else {
        if(this.totalIntentos < 3) {
          this.totalIntentos++;
          this.$swal({
            icon: 'error',
            title: 'Número no valido',
            text: 'El número de móvil introducido no existe. Por favor, vuelve a intentarlo.',
          })
        } else {
          this.codError = '';
          this.msg = 'Has agotado el número de intentos. Por favor, vuelve a escanear el código QR.';
          this.type = 'error';
          this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
        }

        document.getElementById('idBtnBuscar').disabled=false;
      }
    },
    catchErrors(error){
      if(error.request) {
        if (error.request.status == 429) {
          this.codError = error.request.status
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          console.log(error.request)
        }
      }
    },
    redirect(codError, title, msg, type, token, closeSession) {  
      this.$router.push({name: 'Messages',params: {codError: codError, title: title, msg: msg, type:type, token:token, closeSession:closeSession}});
    },
  }
}
</script>

<style scoped>
h3 {
  margin: 10px 0px 0px 0px!important;
  font-size: 20px!important;
}

a {
  color: darkslategrey;
}

form {
  width: 100%;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] { 
  -moz-appearance:textfield;
}

input[type=number]:focus,
input[type=number]:hover{
  border-color: #00f9a9 !important;
}

input[type=number]:-webkit-autofill {
  box-shadow: unset!important;
  border-color: #00f9a9!important;
}

input, button {
  height: 55px;
  font-size: 17px!important;
}

i.mobile {
  font-size: 35px;
}


.ui[class*="left icon"].input>i.icon {
  height: 100%;
  width: 45px;
}

.ui[class*="left icon"].input>input {
  padding-left: 45px!important;
}

#contain {
  margin: auto!important;
  width: 90%;
  left: 5%;
  height: 85%;
  position: absolute;
  top: 10%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

.ui.form .field {
  margin: 0 0 2em!important;
}

.row {
  width: 100%;
}

.content {
  height: 100%;
  width: 100%;
  font-size: 18px!important;
} 

.field {
  width: 100%;
}

.formulario {
  height: 55%;
  padding-top: 50px;
  margin-top: 25px;
}

.mensaje {
  display: flex;
  padding-top: 10px;
}

.iconoMsgInfo {
  height: 30%;
  padding-top: 35px!important;
}

.hapiick {
  color: black !important;
  background-color: #00f9a9 !important;
}

.icono {
  width:20%;
  margin: auto;
}

.icono i {
  font-size: 45px;
  width: 100%;
}

.msgInfo{
  width: 80%;
}

.icono, .msgInfo {
  height: 80px;
  text-align: justify!important;
  display:flex;
  align-items: center;
  color: black;
}

@media screen and (max-width: 768px) and (min-height: 200px) and (max-height: 649px){   
  #contain {
    padding-top: 40px!important;
  }

  .formulario {
    padding-top: 15px;
  }

  .iconoMsgInfo {
    padding-top: 25px!important;
  }
}

@media screen and (max-width: 768px) and (min-height: 650px) and (max-height: 800px) {   
  #contain {
    padding-top: 60px!important;
  }

  .formulario {
    padding-top: 25px;
  }

  .iconoMsgInfo {
    padding-top: 35px!important;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px){   
  #contain {
    padding-top: 30px!important;
  }

  .formulario {
    padding-top: 20px;
  }

  .iconoMsgInfo {
    padding-top: 20px!important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px){   
  #contain {
    padding-top: 30px!important;
  }

  .formulario {
    padding-top: 20px;
  }

  .iconoMsgInfo {
    padding-top: 20px!important;
  }
}

@media screen and (min-width: 1200px){   
  #contain {
    padding-top: 30px!important;
  }

  .formulario {
    padding-top: 20px;
  }

  .iconoMsgInfo {
    padding-top: 20px!important;
  }
}
</style>
